import button from '../Button/defaultProps';
import paper from '../Paper/defaultProps';
import appBar from '../AppBar/defaultProps';
import alert from '../Alert/defaultProps';
import linearProgress from '../LinearProgress/defaultProps';
import iconButton from '../IconButton/defaultProps';

const defaultProps = {
  button,
  paper,
  appBar,
  alert,
  linearProgress,
  iconButton,
};

export default defaultProps;
